module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "envelope"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.latest-brief')))]), _c('template', {
    slot: "content"
  }, [_c('comment', {
    attrs: {
      "event": {
        data: _vm.comment,
        type: "Comment"
      }
    }
  })], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09ddbbe3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/single-comment-box/SingleCommentBox.vue
// module id = 2002
// module chunks = 1